import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const DirectoryIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M2 6.22222V17.3333C2 17.9227 2.23413 18.4879 2.65087 18.9047C3.06762 19.3214 3.63285 19.5556 4.22222 19.5556H19.7778C20.3671 19.5556 20.9324 19.3214 21.3491 18.9047C21.7659 18.4879 22 17.9227 22 17.3333V8.44444C22 7.85507 21.7659 7.28984 21.3491 6.8731C20.9324 6.45635 20.3671 6.22222 19.7778 6.22222H13.1111L10.8889 4H4.22222C3.63285 4 3.06762 4.23413 2.65087 4.65087C2.23413 5.06762 2 5.63285 2 6.22222Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

DirectoryIcon.displayName = 'DirectoryIcon';
